<!-- 页面体组件：统一设置背景处理-->
<template>
    <div class="body-container">
        <div class="page-content-box" :style="contentBoxStyle">
            <!-- 页面中的内容将放在此区间 -->
            <slot></slot>
        </div>
        
    </div>
  </template>

  <script>

    export default {
      components: { },
      props: {        
        contentBoxStyle: null,
      },
      data() {
          return {

          };
        },
      methods: {},
      created() {},
      mounted() {}
    };
  </script>

  <style scoped>

  </style>



// WEBPACK FOOTER //
// src/components/channelbody/index.vue